import PropTypes from 'prop-types';

import styles from './Typography.module.scss';

const variants = [
  {
    name: 'DisplayXXL',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 'xxl'
  },
  {
    name: 'DisplayXL',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 'xl'
  },
  {
    name: 'DisplayL',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 'l'
  },
  {
    name: 'DisplayM',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 'm'
  },
  {
    name: 'DisplayS',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 's'
  },
  {
    name: 'DisplayXS',
    htmlElement: 'h1',
    variantClassName: 'display',
    size: 'xs'
  },
  {
    name: 'HeadingL',
    htmlElement: 'h1',
    variantClassName: 'heading',
    size: 'l'
  },
  {
    name: 'HeadingM',
    htmlElement: 'h1',
    variantClassName: 'heading',
    size: 'm'
  },
  {
    name: 'HeadingS',
    htmlElement: 'h1',
    variantClassName: 'heading',
    size: 's'
  },
  {
    name: 'ParagraphXL',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 'xl'
  },
  {
    name: 'ParagraphL',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 'l'
  },
  {
    name: 'ParagraphMTall',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 'm-tall'
  },
  {
    name: 'ParagraphMShort',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 'm-short'
  },
  {
    name: 'ParagraphSTall',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 's-tall'
  },
  {
    name: 'ParagraphSShort',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 's-short'
  },
  {
    name: 'ParagraphXS',
    htmlElement: 'p',
    variantClassName: 'paragraph',
    size: 'xs'
  },
  {
    name: 'LabelM',
    htmlElement: 'p',
    variantClassName: 'label',
    size: 'm'
  },
  {
    name: 'LabelS',
    htmlElement: 'p',
    variantClassName: 'label',
    size: 's'
  }
];

const Typography = variants.reduce((component, variant) => {
  const variantComponent = ({ dataTest = undefined, children }) => (
    <variant.htmlElement
      className={`${styles.typography} ${styles[variant.variantClassName]} ${
        styles[`${variant.variantClassName}__${variant.size}`]
      }`}
      data-test={dataTest}
    >
      {children}
    </variant.htmlElement>
  );

  variantComponent.propTypes = {
    children: PropTypes.element.isRequired,
    dataTest: PropTypes.string
  };

  return {
    ...component,
    [variant.name]: variantComponent
  };
}, {});

export default Typography;
